import styled from 'styled-components';
import {
  ButtonBase,
  BaseColumnWrap,
} from '../../../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
export const AddBtnOuterWrapper = styled.div(
  props => `
    width:100%;
    display:flex;
    position:relative;
    // justify-content: flex-end;
    `,
);
export const AddBtn = styled(ButtonBase)(
  props => `
      width:100%;
      display:flex;
      background-color: ${props.bgColor || props.theme.colors.goWhite.base};
      padding: ${props.theme.spacing.small} ${props.theme.spacing.base};
      border:1px solid ${props.theme.colors.ash.dark};
      border-radius: ${props.theme.misc.borderRadius.custom(20)};
      color:${props.theme.colors.goBrandBlue.base};
      align-items: center;
      justify-content: center;
      font-size: ${props.theme.font.custom(18)};
      font-weight: 600;
      cursor:pointer;
      text-transform: capitalize;
      &:disabled{
        background-color: ${props.theme.colors.downriver.light};
        border:0.1rem solid ${props.theme.colors.downriver.light};
        cursor: not-allowed;
      }
    `,
);

// export const UpgradeDowngradeBtn = styled.span(
//   props => `
//       width:100%;
//       display:flex;
//       padding: ${props.theme.spacing.small} ${props.theme.spacing.base};
//       border:1px solid ${props.theme.colors.ash.dark};
//       border-radius: ${props.theme.misc.borderRadius.custom(20)};
//       box-shadow: 0 .8rem .6rem -.6rem ${props.theme.colors.shadow.light};
//       color:${props.theme.colors.goBrandBlue.base};
//       align-items: center;
//       justify-content: space-around;
//       font-size: ${props.theme.font.custom(18)};
//   //       font-weight: 600;
//       cursor:pointer;
//       `,
// );

export const UpgradeDowngradeBtn = styled(ButtonBase)(
  props => `
      width:100%;
      display:flex;
      background-color: ${props.bgColor || props.theme.colors.goWhite.base};
      padding: ${props.theme.spacing.small} 0;
      border:1px solid ${props.theme.colors.ash.dark};
      border-radius: ${props.theme.misc.borderRadius.custom(20)};
      box-shadow: 0 .8rem .6rem -.6rem ${props.theme.colors.shadow.light};
      color:${props.theme.colors.goBrandBlue.base};
      align-items: center;
      justify-content: space-around;
      font-size: ${props.theme.font.custom(18)};
        font-weight: 600;
      cursor:pointer;
      &:disabled{
        background-color: ${props.theme.colors.downriver.light};
        border:0.1rem solid ${props.theme.colors.downriver.light};
        cursor: not-allowed;
      }
      `,
);

export const LessOccupnacyModalContent = styled.div(
  props => `
  padding: 2rem;
`,
);

export const LessOccupnacyModalInfoText = styled.p(
  props => `
font-size: 1.6rem;
padding: 0 0 0 1rem;
position: relative;
`,
);

export const ModalActionContainer = styled.div(
  props => `
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top:30px;
  align-items:center
`,
);

export const EditSelectionButton = styled.div(
  props => `
  color:${props.theme.colors.goBrandBlue.base};
  font-size:14px;
  font-weight: 600;
  margin-right: 16px;
  cursor:pointer
  `,
);
